import React from 'react';
import images from '../../data/p15images.json';

const src = (path, w) => (w ? `/p15/${path.replace('/', `/w${w}/`)}` : `/p15/${path}`);

export const P15Image = ({ group, id, className = '', sizes = '(max-width: 700px) 100vw, 480px', priority = false, contain = false, testId }) => {
  const rec = images[group]?.[id];
  if (!rec) return null;
  return (
    <img
      src={src(rec.image, 960)}
      srcSet={`${src(rec.image, 480)} 480w, ${src(rec.image, 960)} 960w, ${src(rec.image)} 1536w`}
      sizes={sizes}
      width={1536} height={1024}
      alt={rec.alt}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      className={`block w-full h-auto ${contain ? 'object-contain' : 'object-cover'} ${className}`}
      style={{ aspectRatio: '3 / 2' }}
      data-testid={testId}
    />
  );
};
